import { render, staticRenderFns } from "./entity-change-history-modal.vue?vue&type=template&id=47b16fe4&scoped=true"
import script from "./entity-change-history-modal.vue?vue&type=script&lang=js"
export * from "./entity-change-history-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b16fe4",
  null
  
)

export default component.exports